module.exports = __webpack_public_path__ + "img/bonkers-logo-white.f62b487.svg";